<script>
    let isLoggedIn = false;
    import Login from './Login.svelte';
    export let trainerData = {};
    import Game from './Game.svelte';
    import Navbar from './Navbar.svelte';
    import Footer from './Footer.svelte';
    import Selectors from './Selectors.svelte';
    import Header from './Header.svelte';
    import Info from './Info.svelte';
    import Swal from 'sweetalert2';
    import { trainerTools } from './trainertools.js';

    export let viewOptions = {
        showClosed: true,
        showRunning: true,
        showOther: true,
    };
    checkLogin();
    const LOGIN_TIMEOUT = 3600000;

    async function checkLogin() {
        let session = JSON.parse(localStorage.getItem('sessionActivatedAt'));
        console.log(Number(session) + LOGIN_TIMEOUT);
        let now = Date.now();
        if (!session || Number(session) + LOGIN_TIMEOUT < now) {
            if (session && Number(session) + LOGIN_TIMEOUT < now) {
                Swal.fire('Session terminated. Logged out');
            }
            logout();
            return;
        }
        isLoggedIn = true;
        trainerData = JSON.parse(localStorage.getItem('trainerDataCache'));
        refreshAll();
        localStorage.setItem('sessionActivatedAt', JSON.stringify(now));
    }

    function refreshView() {
        trainerData.startedGames = trainerData.startedGames;
    }
    function logout() {
        console.log('logout');
        localStorage.removeItem('sessionActivatedAt');
        localStorage.removeItem('trainerDataCache');
        isLoggedIn = false;
    }
    async function refreshAll() {
        console.log('refr');
        const newGames = await trainerTools.refreshGames(trainerData);
        trainerData.startedGames = newGames;
        const newCredits = await trainerTools.getCredits(trainerData);
        trainerData.playsleft = newCredits;
        refreshView();
    }
</script>

{#if !isLoggedIn}<Login {trainerData} bind:isLoggedIn />
{:else}
    <Navbar on:logout={logout} />
    <div class="main">
        <Header />
        <div class="info__wrap">
            <Info {trainerData} bind:viewOptions />

            <Selectors
                on:createGame={async (ev) => {
                    await trainerTools.createGame(
                        trainerData,
                        ev.detail.players
                    );
                    refreshAll();
                }}
                on:refresh={refreshAll}
            />
        </div>

        {#if trainerData.startedGames.length > 0}
            <div class="container">
                {#each trainerData.startedGames.slice().reverse() as game}
                    {#if (game.isGameEnd && viewOptions.showClosed) || (game.isGameOn && !game.isGameEnd && viewOptions.showRunning) || (!game.isGameOn && !game.isGameEnd && viewOptions.showOther)}
                        <Game
                            {game}
                            on:deleteGame={async (event) => {
                                await trainerTools.deleteGameFromServer(
                                    event,
                                    trainerData
                                );
                                refreshAll();
                            }}
                            on:addDeletePlayer={async (event) => {
                                await trainerTools.addOrDeletePlayer(
                                    event,
                                    trainerData
                                );
                                refreshAll();
                            }}
                        />
                    {/if}
                {/each}
            </div>
        {/if}
    </div>
    <Footer />
{/if}
